import { Button, Form, Modal, Switch, Input } from "antd";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { AppstoreAddOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonActiveModal } from "../../../components/Buttons/ButtonActiveModal";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { usePageCategoriesData } from "../../../hooks/controlPanel";
const { Search } = Input;

export const PageCategories = () => {
	const {
		searchValue,
		activeModal,
		activeSubModal,
		typeModal,
		loadingButton,
		categoryForm,
		subCategoryForm,
		isLoading,
		handleOpenModalCreate,
		closeModal,
		closeSubModal,
		onFinishCategory,
		onFinishSubCategory,
		tableFilterDataCategories,
		handleChange,
		columns,
		tableProps,
		pagination,
	} = usePageCategoriesData();

	return (
		<div className="lg:p-12 p-4 w-full h-full flex flex-col gap-6">
			<CardDetailProject
				title="Categorías"
				headerChildren={
					<>
						<ButtonActiveModal
							icon={<AppstoreAddOutlined />}
							action={handleOpenModalCreate}
							className="bg-primaryTwo hover:bg-primaryTwoHover px-6 py-2 flex justify-center items-center lg:ml-auto"
							size={{ w: 132, h: 32 }}
							title="Crear categoría"
						/>

						<Search
							placeholder="Búsqueda por categoría"
							onChange={handleChange}
							value={searchValue}
							className="w-full md:max-w-64 order-last sm:mt-2 md:mt-0"
						/>
					</>
				}
			>
				<div className="w-full max-w-[540px] flex justify-center mx-auto">
					<TableGeneral
						column={columns}
						loading={isLoading}
						state={tableFilterDataCategories}
						pagination={pagination}
						tableProps={tableProps}
					/>
				</div>
			</CardDetailProject>
			<Modal
				title={`${typeModal === 0 ? "Crear clasificación" : "Editar clasificación"}`}
				width={400}
				onCancel={closeModal}
				open={activeModal}
				footer={[]}
			>
				<Form form={categoryForm} name="areas_user" layout="vertical" style={{ width: "100%" }} onFinish={onFinishCategory}>
					{typeModal === 0 && (
						<div className="flex items-center justify-start gap-4">
							<Form.Item name="isActive" label="¿Esta activo?" valuePropName="checked" className="flex h-6 relative top-3">
								<Switch className="ml-4 relative bottom-[6px]" />
							</Form.Item>
						</div>
					)}
					<Form.Item
						name="name"
						label="Nombre"
						rules={[
							{
								required: true,
								message: "Nombre",
								whitespace: true,
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item className="w-full flex justify-end m-0 mt-4">
						<Button type="primary" htmlType="submit" loading={loadingButton}>
							{typeModal === 0 ? "Crear" : "Editar"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
			<Modal title={`Agrega subcategorias`} width={400} onCancel={closeSubModal} open={activeSubModal} footer={[]}>
				<Form form={subCategoryForm} layout="vertical" onFinish={onFinishSubCategory} style={{ width: "100%" }}>
					<Form.List name="subCategories">
						{(fields, { add, remove }) => {
							return (
								<>
									{fields.map(({ key, name, ...restField }) => {
										return (
											<div key={key} className="flex items-center gap-4">
												<Form.Item
													className="w-full"
													{...restField}
													name={[name, "namesub"]}
													label={"Nombre"}
													rules={[
														{
															required: true,
															message: "Por favor necesita nombre!",
														},
													]}
												>
													<Input placeholder="Nombre" />
												</Form.Item>
												<MinusCircleOutlined onClick={() => remove(name)} />
											</div>
										);
									})}
									<Form.Item>
										<Button type="ghost" onClick={() => add()} block icon={<PlusOutlined />}>
											Entrada de datos
										</Button>
									</Form.Item>
								</>
							);
						}}
					</Form.List>
					<Form.Item className="w-full flex justify-end m-0 mt-4">
						<Button type="primary" htmlType="submit" loading={loadingButton}>
							Agregar
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};
